import {
  Button,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect, RouteComponentProps, useHistory} from 'react-router-dom';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import PagedView from 'Shared/components/PagedView/PagedView';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import {getAppEntryType, getWorkItems, viewWorkItemImage} from 'ApplicationEntry/ducks/workQueue';
import {createSnackbar} from 'Core/ducks/snackbar';
import {copyToClipboard} from 'Shared/utilities/CopyToClipboard';
import './WorkQueue.sass';
import DateUtility from 'Shared/utilities/DateUtility';
import {ApplicationModeType} from 'ApplicationEntry/models/ApplicationModeType';
import Loading from 'Shared/components/Loading';
import ModularHost from 'Shared/components/ModularHost/ModularHost';
import ToolbarHeader from 'Shared/components/Toolbar/ToolbarHeader';
import ActionsMenu from 'Shared/components/PagedView/ActionsMenu';
import {updateWork, UpdateWork} from 'ApplicationEntry/models/AWDStatus/UpdateWork';
import application from 'ApplicationEntry/ducks/application';
import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';

type WorkQueueProps = {} & RouteComponentProps;

const WorkQueue = (props: WorkQueueProps) => {
  const dispatch = useDispatch();
  const {workQueue} = useSelector((state: ReducerState) => state);
  const modalApplication = useSelector((state: ReducerState) => state.application);
  const history = useHistory();
  useBreadcrumbs('Work Queue', props.location.pathname);

  const getValuePolicyRecord = sessionStorage.getItem('policyRecordNotFoundKey');

  useEffect(() => {
    dispatch(getWorkItems());
  }, [dispatch]);

  useEffect(() => {
    if (getValuePolicyRecord === 'policyRecordNotFoundValue')
      dispatch(createSnackbar('POLICY RECORD NOT FOUND IN L70 SYSTEM'));
  }, []);

  let workQueueData = workQueue.key === 'Loaded' ? workQueue.Data.result : null;

  const issuePolicyNumber = sessionStorage.getItem('IssuedPolicy');
  const issuePolicyNumber0 = sessionStorage.getItem('IssuedPolicy0');
  const issuePolicyNumber1 = sessionStorage.getItem('IssuedPolicy1');
  const issuePolicyNumber2 = sessionStorage.getItem('IssuedPolicy2');

  const awdworkkeyid = sessionStorage.getItem('awdworkkeyid');
  const businessAreaNameContent = sessionStorage.getItem('businessAreaNameContent');
  const typeNameContent = sessionStorage.getItem('typeNameContent');
  const statusNameContent = sessionStorage.getItem('statusNameContent');

  const awdworkkeyid0 = sessionStorage.getItem('awdworkkeyid0');
  const businessAreaNameContent0 = sessionStorage.getItem('businessAreaNameContent0');
  const typeNameContent0 = sessionStorage.getItem('typeNameContent0');
  const statusNameContent0 = sessionStorage.getItem('statusNameContent0');

  const awdworkkeyid1 = sessionStorage.getItem('awdworkkeyid1');
  const businessAreaNameContent1 = sessionStorage.getItem('businessAreaNameContent1');
  const typeNameContent1 = sessionStorage.getItem('typeNameContent1');
  const statusNameContent1 = sessionStorage.getItem('statusNameContent1');

  const awdworkkeyid2 = sessionStorage.getItem('awdworkkeyid2');
  const businessAreaNameContent2 = sessionStorage.getItem('businessAreaNameContent2');
  const typeNameContent2 = sessionStorage.getItem('typeNameContent2');
  const statusNameContent2 = sessionStorage.getItem('statusNameContent2');

  const mode = sessionStorage.getItem('mode');

  return (
    <>
      <ModularHost>
        {statusNameContent === 'PASSED' ? (
          <>
            <ToolbarHeader title="Last Policy Details" />
            <TableContainer component={Paper} className="last-policy-details__policy">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Business Area</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>AWD Status</TableCell>
                    <TableCell>AWD Key</TableCell>
                    <TableCell>Last Policy Number</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <>
                    {issuePolicyNumber && (
                      <TableRow key={0}>
                        <TableCell>{businessAreaNameContent}</TableCell>
                        <TableCell>{typeNameContent}</TableCell>
                        <TableCell>{statusNameContent}</TableCell>
                        <TableCell>{awdworkkeyid}</TableCell>
                        <TableCell>{issuePolicyNumber}</TableCell>
                      </TableRow>
                    )}

                    {mode !== 'Quality' && issuePolicyNumber0 && (
                      <TableRow key={1}>
                        <TableCell>{businessAreaNameContent0}</TableCell>
                        <TableCell>{typeNameContent0}</TableCell>
                        <TableCell>{statusNameContent0}</TableCell>
                        <TableCell>{awdworkkeyid0}</TableCell>
                        <TableCell>{issuePolicyNumber0}</TableCell>
                      </TableRow>
                    )}
                    {mode !== 'Quality' && issuePolicyNumber1 && (
                      <TableRow key={2}>
                        <TableCell>{businessAreaNameContent1}</TableCell>
                        <TableCell>{typeNameContent1}</TableCell>
                        <TableCell>{statusNameContent1}</TableCell>
                        <TableCell>{awdworkkeyid1}</TableCell>
                        <TableCell>{issuePolicyNumber1}</TableCell>
                      </TableRow>
                    )}
                    {mode !== 'Quality' && issuePolicyNumber2 && (
                      <TableRow key={3}>
                        <TableCell>{businessAreaNameContent2}</TableCell>
                        <TableCell>{typeNameContent2}</TableCell>
                        <TableCell>{statusNameContent2}</TableCell>
                        <TableCell>{awdworkkeyid2}</TableCell>
                        <TableCell>{issuePolicyNumber2}</TableCell>
                      </TableRow>
                    )}
                  </>
                </TableBody>
              </Table>
            </TableContainer>
          </>
        ) : (
          <> </>
        )}

        <PagedView pagedViewKey="workQueue" data={workQueue} loadMore={() => {}}>
          {columnProps => (
            <>
              <Column {...columnProps} title="Summary" default>
                {workQueueItem => workQueueItem.summary}
              </Column>
              <Column {...columnProps} title="Date Added" default>
                {workQueueItem => DateUtility.toFormattedDateAsUtc(new Date(workQueueItem.date))}
              </Column>

              <Column {...columnProps} title="" default isActions>
                {workQueueItem =>
                  workQueueItem.summary.includes('CONVERT') &&
                  !workQueueItem.summary.includes('QUALITY') && (
                    <>
                      <Button
                        variant="contained"
                        className="view-work-item-button"
                        color="primary"
                        onClick={() => {
                          if (workQueueItem.sourceInstanceId) {
                            dispatch(viewWorkItemImage(workQueueItem.sourceInstanceId));
                          }

                          dispatch(getAppEntryType(workQueueItem.awdworkkeyid, ApplicationType.Group, 'CONVERT'));
                          history.push(
                            ApplicationEntryRouteConstants.ApplicationEntryWizard +
                              (workQueueItem.sourceInstanceId
                                ? `?sourceInstanceId=${workQueueItem.sourceInstanceId}`
                                : '')
                          );
                        }}
                      >
                        CONVERT Work Item - GROUP
                      </Button>
                    </>
                  )
                }
              </Column>
              {/* </div> */}

              {/* <div className="colConvertOrd"> */}
              <Column {...columnProps} title="" default isActions>
                {workQueueItem =>
                  workQueueItem.summary.includes('CONVERT') &&
                  !workQueueItem.summary.includes('QUALITY') && (
                    <>
                      <Button
                        variant="contained"
                        className="view-work-item-button"
                        color="primary"
                        onClick={() => {
                          if (workQueueItem.sourceInstanceId) {
                            dispatch(viewWorkItemImage(workQueueItem.sourceInstanceId));
                          }

                          dispatch(getAppEntryType(workQueueItem.awdworkkeyid, ApplicationType.Ordinary, 'CONVERT'));
                          history.push(
                            ApplicationEntryRouteConstants.ApplicationEntryWizard +
                              (workQueueItem.sourceInstanceId
                                ? `?sourceInstanceId=${workQueueItem.sourceInstanceId}`
                                : '')
                          );
                        }}
                      >
                        CONVERT Work Item - ORD
                      </Button>
                    </>
                  )
                }
              </Column>
              {/* </div> */}
              {/* <div className="colCOnvertQual"> */}
              <Column {...columnProps} title="" default isActions>
                {workQueueItem =>
                  workQueueItem.summary.includes('CONVERT') &&
                  workQueueItem.summary.includes('QUALITY') && (
                    <>
                      <Button
                        variant="contained"
                        className="view-work-item-button"
                        color="primary"
                        onClick={() => {
                          if (workQueueItem.sourceInstanceId) {
                            dispatch(viewWorkItemImage(workQueueItem.sourceInstanceId));
                          }

                          dispatch(getAppEntryType(workQueueItem.awdworkkeyid));
                          history.push(
                            ApplicationEntryRouteConstants.ApplicationEntryWizard +
                              (workQueueItem.sourceInstanceId
                                ? `?sourceInstanceId=${workQueueItem.sourceInstanceId}`
                                : '')
                          );
                        }}
                      >
                        Work Item
                      </Button>
                    </>
                  )
                }
              </Column>
              {/* </div> */}
              {/* <div className="colConvertCopyAWDKey"> */}
              <Column {...columnProps} title="" default>
                {workQueueItem =>
                  workQueueItem.summary.includes('CONVERT') &&
                  workQueueItem.sourceInstanceId && (
                    <Button
                      variant="contained"
                      color="primary"
                      className="copy-awd-key-button"
                      onClick={() => {
                        copyToClipboard(workQueueItem.awdworkkeyid!)();
                        dispatch(createSnackbar('Key Copied to Clipboard'));
                      }}
                    >
                      <i className="fa fa-copy copy-awd-key-button__copy-icon" />
                      Copy AWD Key
                    </Button>
                  )
                }
              </Column>
              {/* </div> */}

              {/* <div className="colNotConvertWorkType"> */}
              <Column {...columnProps} title="" default isActions>
                {workQueueItem =>
                  !workQueueItem.summary.includes('CONVERT') && (
                    <>
                      <Button
                        variant="contained"
                        className="view-work-item-button"
                        color="primary"
                        onClick={() => {
                          if (workQueueItem.sourceInstanceId) {
                            dispatch(viewWorkItemImage(workQueueItem.sourceInstanceId));
                          }

                          dispatch(getAppEntryType(workQueueItem.awdworkkeyid));

                          history.push(
                            ApplicationEntryRouteConstants.ApplicationEntryWizard +
                              (workQueueItem.sourceInstanceId
                                ? `?sourceInstanceId=${workQueueItem.sourceInstanceId}`
                                : '')
                          );
                        }}
                      >
                        Work Item
                      </Button>
                      {workQueueItem.sourceInstanceId && (
                        <Button
                          variant="contained"
                          color="primary"
                          className="copy-awd-key-button"
                          onClick={() => {
                            copyToClipboard(workQueueItem.awdworkkeyid!)();
                            dispatch(createSnackbar('Key Copied to Clipboard'));
                          }}
                        >
                          <i className="fa fa-copy copy-awd-key-button__copy-icon" />
                          Copy AWD Key
                        </Button>
                      )}
                    </>
                  )
                }
              </Column>
            </>
          )}
        </PagedView>
      </ModularHost>
    </>
  );
};

export default WorkQueue;
